import styled from "styled-components";
import { LinkLegendBoxProps } from "../../../constants/types";
import { useEffect, useState } from "react";
import LinkLegend from "../../atoms/link/LinkLegend";
import { COLORS } from "../../../constants/colors";

const LinkLegendBox = (props: LinkLegendBoxProps) => {
  const [legends, setLegends] = useState<JSX.Element[]>([]);

  useEffect(() => {
    setLegends(
      props.data.map((data, index) => <LinkLegend key={index} data={data} />)
    );
  }, [props.data]);
  return <Container>{legends}</Container>;
};

export default LinkLegendBox;

const Container = styled.div`
  width: 100%;
  height: 38%;
  border: 0.2vw solid ${COLORS.lightGray2};
  box-sizing: border-box;

  display: flex;
  align-content: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`;
